import { Suspense, useEffect, useState } from 'react';
import LandingPage from './pages/LandingPage';
import CouponsPage from './pages/CouponsPage';
import { couponsLanguage } from './pages/SiteBrand';
import { Impressum, Privacy, Terms, Cookies, TeamMemberProfile, CitySeekCityLab } from './pages/lazyPages';
export default function App() {
  const [pathname, setPathname] = useState(window.location.pathname);
  useEffect(() => {
    const onNavigate = () => setPathname(window.location.pathname);
    window.addEventListener('popstate', onNavigate);
    return () => window.removeEventListener('popstate', onNavigate);
  }, []);
  const path = pathname.replace(/\/+$/, '').toLowerCase() || '/';
  // /landing is the same English landing page as "/", reachable from the app
  // host at an address that shows it to everybody rather than sending a
  // returning visitor into the app. The server hands back the prerendered "/"
  // document for it, so this has to agree or the router replaces a correct
  // page with a 404 and hydration fails.
  // CitySeek Coupons for businesses. Prerendered like the landing page, so it is
  // imported here rather than lazily: a lazy page would not match the HTML it hydrates.
  // city-seek.store and the old /store address both forward here. The language
  // sits at the end (/coupons/de); /de/coupons is the old shape, 301'd by the server.
  if (['/coupons', '/coupons/de', '/coupons/tr', '/de/coupons', '/tr/coupons'].includes(path)) return <CouponsPage language={couponsLanguage(path)} />;
  if (['/', '/landing', '/de', '/tr'].includes(path)) return <LandingPage language={path === '/de' ? 'de' : path === '/tr' ? 'tr' : 'en'} />;
  const page = path === '/impressum' ? <Impressum /> : path === '/privacy' ? <Privacy /> : path === '/terms' ? <Terms /> : path === '/cookies' ? <Cookies /> : ['/cityseek_citylab', '/cityseek_popup_meetup'].includes(path) ? <CitySeekCityLab /> : path === '/team/safa-kaskaya' ? <TeamMemberProfile slug="safa-kaskaya" /> : path === '/team/umut-bilgic' ? <TeamMemberProfile slug="umut-bilgic" /> : <main style={{padding: '10vw'}}><h1>Page not found</h1><a href="/">Back to CitySeek</a></main>;
  return <Suspense fallback={<p role="status" style={{padding: '10vw'}}>CitySeek…</p>}>{page}</Suspense>;
}
